import React, { useState, useEffect } from "react"
import {
  Card,
  CardBody,
  Container,
  Row,
  Col,
  FormGroup,
  Label,
} from "reactstrap"
import TextInputWithLabel from "components/Common/TextInputWithLabel"
import SButton from "components/Common/Button"
import Table from "./Table"
import { useDispatch, useSelector } from "react-redux"
import { getAuthor, getCraftsman, getUsers } from "store/actions"
import Skeleton from "react-loading-skeleton"
import { useHistory } from "react-router-dom"
import Breadcrumb from "components/Common/Breadcrumb"
import SelectBox from "components/Common/SelectBox"

export default function Administrator() {
  const dispatch = useDispatch()
  const history = useHistory()
  // global state
  const store = useSelector(({ Users }) => Users)
  const [pagination, setPagination] = useState({
    page: 0,
    size: 10,
  })

  const [count, setCount] = useState(100)

  useEffect(() => {
    setCount(store?.data?.totalPages)
  }, [store?.data])

  // local state
  const [name, setName] = useState("")
  const [author, setAuthor] = useState("")
  const [authorFilter, setAuthorFilter] = useState({ value: "", label: "" })
  const params = {
    name: name,
    authority: author,
    page: pagination.page,
    size: pagination.size,
  }

  const fetchUsers = params => {
    dispatch(getUsers(params))
  }

  useEffect(() => {
    fetchUsers(params)
  }, [pagination])

  useEffect(() => {
    dispatch(getAuthor())
    dispatch(getCraftsman())
  }, [dispatch])

  const onSelect = e => {
    setAuthorFilter(e ? e : "")
    setAuthor(e ? e.value : "")
  }

  return (
    <div className="page-content">
      <Container fluid>
        <Breadcrumb title={"管理者"} breadcrumbList={[]} />
        <Card>
          <CardBody>
            <Row>
              <Col lg={2}>
                <TextInputWithLabel
                  label={"管理者名"}
                  placeholder={""}
                  type="text"
                  name="suppliers"
                  onChange={e => setName(e.target.value)}
                  value={name}
                />
              </Col>
              <Col lg={2}>
                <SelectBox
                  label={"権限"}
                  placeholder={""}
                  value={authorFilter}
                  name="suppliers"
                  options={[
                    {
                      label: "一般",
                      value: "一般",
                    },
                    {
                      label: "全権限管理者",
                      value: "全権限管理者",
                    },
                  ]}
                  onChange={onSelect}
                />
              </Col>
              <Col lg={8} className="align-self-end">
                <SButton
                  onClick={() => {
                    setPagination({ page: 0, size: 10 })
                    fetchUsers({ ...params, page: 0, size: 10 })
                  }}
                  className="button"
                >
                  検索
                </SButton>
              </Col>
            </Row>
          </CardBody>
        </Card>

        <Card>
          <CardBody>
            <div className="d-flex justify-content-end align-self-end mb-3">
              <SButton
                onClick={() => history.push("/administrator/create")}
                className="button"
              >
                新規追加
              </SButton>
            </div>
            {store.status === "process" ? (
              <Skeleton count={5} />
            ) : (
              <>
                {/* <TableContainer /> */}
                <Table
                  data={store?.data}
                  page={pagination.page}
                  size={pagination.size}
                  count={count}
                  setParams={setPagination}
                  params={pagination}
                />
              </>
            )}
          </CardBody>
        </Card>
      </Container>
    </div>
  )
}
